import { Table, Tag } from "antd";
import { STATUS_WITHDRAW } from "store/string";
import { getTime } from "util/time.function";
import numeral from "numeral";
import React from "react";
import { useWithdrawLists } from "hook/finance/withdraw/useWithdraw";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const RequestTable = () => {
  // -------------------------- VAR -----------------------------
  const { data } = useWithdrawLists();

  console.log("list request:" + data);
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      title: "Thời gian",
      dataIndex: "createAt",
      key: "createAt",
      render: (value) => (
        <span style={{ fontSize: 12 }}>
          {getTime(value, "DD/MM/YYYY HH:mm:ss")}
        </span>
      ),
    },
    {
      title: "Mã Tracker",
      dataIndex: "id",
      key: "id",
      render: (value) => <Tag style={{ fontSize: 10 }}>{value}</Tag>,
    },
    {
      title: "Số tiền yêu cầu rút (vnd)",
      dataIndex: "amount",
      key: "amount",
      render: (value) => <>{numeral(value).format("0,0")}</>,
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (value) => getStattus(value),
    },
  ];

  const getStattus = (value) => {
    const select = STATUS_WITHDRAW?.find((s) => s?.value === value);
    const color = select?.color;
    const label = select?.label;
    return (
      <Tag color={color} style={{ borderRadius: 20 }}>
        {label}
      </Tag>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={data === null}
      pagination={{ pageSize: 20 }}
      scroll={{ x: "fit-width" }}
    />
  );
};
export default RequestTable;
